import { S3Client as AwsS3Client, PutObjectCommand, GetObjectCommand } from '@aws-sdk/client-s3';
import { getSignedUrl } from '@aws-sdk/s3-request-presigner';
import { configForEnvironment } from '../utils';
import { getCredentials } from './Auth';

async function getClient(config: any) {
  return new AwsS3Client({
    region: config.aws_project_region,
    credentials: await getCredentials(),
    requestChecksumCalculation: 'WHEN_REQUIRED',
    responseChecksumValidation: 'WHEN_REQUIRED',
  });
}

export class S3Client {
  static async put(key: string, body: Blob, contentType?: string): Promise<void> {
    const config = configForEnvironment().config;

    const s3 = await getClient(config);
    await s3.send(
      new PutObjectCommand({
        ContentType: contentType,
        Bucket: config.aws_user_files_s3_bucket,
        Key: key,
        Body: body,
      })
    );
  }

  static async constructPreSignedUrl(key: string) {
    const config = configForEnvironment().config;

    const s3 = await getClient(config);
    const command = new GetObjectCommand({
      Bucket: config.aws_user_files_s3_bucket,
      Key: key,
    });

    return getSignedUrl(s3, command, { expiresIn: 604800 }); // seven days
  }
}
